import { motion } from 'motion/react';
import { X, Mail } from 'lucide-react';
import { useLandingContent } from '../../lib/content';

interface Props {
  open: boolean;
  onClose: () => void;
  abandonEmail: string;
  setAbandonEmail: (v: string) => void;
}

export function AbandonModal({ open, onClose, abandonEmail, setAbandonEmail }: Props) {
  const { modals } = useLandingContent('modals');
  const m = modals.abandon ?? {
    title: 'Not ready yet?',
    body: 'Leave your email address so we can email you your current choices. This way you can continue later!',
    cta: 'Mail mijn keuzes',
  };
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl p-8"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600"
        >
          <X className="w-6 h-6" />
        </button>
        <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-6">
          <Mail className="w-8 h-8 text-blue-500" />
        </div>
        <h3 className="text-2xl font-bold mb-2">{m.title}</h3>
        <p className="text-gray-600 mb-6">{m.body}</p>
        <div className="space-y-4">
          <input
            type="email"
            placeholder="your@email.com"
            value={abandonEmail}
            onChange={(e) => setAbandonEmail(e.target.value)}
            className="w-full p-4 bg-gray-50 border-2 border-transparent focus:border-blue-500 rounded-xl outline-none transition-all"
          />
          <button
            onClick={onClose}
            className="w-full py-4 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-colors"
          >
            {m.cta ?? 'Mail mijn keuzes'}
          </button>
        </div>
      </motion.div>
    </div>
  );
}
